import { useNavigate } from '@tanstack/react-router';
import useLogout from 'hooks/useLogout';
import usePageConfig from 'hooks/usePageConfig';
import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { getMarketingUrl } from 'utils/app-urls';
import TopNavView from './TopNavView';

interface TopNavProps {
  children: React.ReactNode;
}

export type NavItem = { name: string; route: string };

const TopNav = (props: TopNavProps) => {
  const navigate = useNavigate();
  const pageConfig = usePageConfig();
  const logout = useLogout();
  // const { theme } = useAppTheme();
  const { theme } = useSelector((state: RootState) => state.theme);

  const [menuOpen, setMenuOpen] = useState(false);
  const navItems = [
    {
      name: 'Explore Investments',
      route: `${getMarketingUrl()}/exploreinvestments`,
    },
    { name: 'Company', route: `${getMarketingUrl()}/about` },
    { name: 'Support', route: `${getMarketingUrl()}/help-centre` },
  ];

  const onLogin = async () => {
    // We need to logout, otherwise the login page will not be accessible from most places
    await logout();
    setMenuOpen(false);
  };

  return (
    <TopNavView
      onLogin={onLogin}
      menuOpen={menuOpen}
      navItems={navItems}
      setMenuOpen={setMenuOpen}
      theme={theme}>
      {props.children}
    </TopNavView>
  );
};

export default TopNav;
